import React from "react";
import CommonHeader from "../../../Components/Common/CommonHeader/CommonHeader";
import { checkButtonAccess } from "../../../Utils/CommonUtils";
import TableWrapper from "../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import useOrderReports from "./Hooks/useReportsColumns";
import { reportsData } from "./Json/reports";
import DownloadModal from "./Modal/DownloadModal";

const ReportListing = () => {
  const { orderReportsColumns } = useOrderReports();

  return (
    <div>
      <CommonHeader
        title={"Reports"}
        newButton={false}
        checkAccessCreate={checkButtonAccess("CREATE", "REPORTS")}
        dash={true}
      />
      <div>
        <TableWrapper
          columns={orderReportsColumns}
          data={reportsData}
          hideTabsWrapper={true}
          hidePagination={true}
        />
      </div>
      <DownloadModal />
    </div>
  );
};

export default ReportListing;
